import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { Banner } from '../components/Feedback';
import { ButtonLink } from '../components/Button';
import { useSession } from './session';
import { PayNowButton } from '../features/billing/PayNowButton';

/**
 * Account-level banners shown above every page: failed payment or cancelled subscription (read-only, export
 * still possible, started periods can be finished — §5.6), and the 2FA requirement for owners (FR-01).
 */
export function SessionBanners() {
  const { t } = useI18n();
  const { account, user, isOwner } = useSession();
  if (!account || !user) return null;
  const s = account.subscriptionStatus;
  return (
    <div className="stack-sm" style={{ marginBottom: ['past_due', 'suspended', 'pending', 'read_only', 'cancelled'].includes(s) || (isOwner && !user.totpEnabled) ? 'var(--card-gap)' : 0 }}>
      {s === 'past_due' && (
        <Banner
          tone="warning"
          title={t('banner.pastDue.title')}
          actions={isOwner ? <ButtonLink to="/instellingen/abonnement" size="sm" variant="secondary">{t('banner.pastDue.action')}</ButtonLink> : undefined}
        >
          {t('banner.pastDue.text')}
        </Banner>
      )}
      {/* Sprint 3A: dunning exhausted → preparing and filing blocked until "Nu betalen". */}
      {s === 'suspended' && (
        <Banner tone="danger" title={t('banner.suspended.title')} actions={isOwner ? <PayNowButton label="paywall.pay" size="sm" /> : undefined}>
          {t('banner.suspended.text')}
        </Banner>
      )}
      {s === 'pending' && (
        <Banner tone="warning" title={t('banner.pending.title')} actions={isOwner ? <PayNowButton label="paywall.finish" size="sm" variant="secondary" /> : undefined}>
          {t('banner.pending.text')}
        </Banner>
      )}
      {s === 'cancelled' && (
        <Banner tone="info" title={t('banner.cancelled.title')}>
          {t('banner.cancelled.text')}
        </Banner>
      )}
      {s === 'read_only' && (
        <Banner tone="warning" title={t('banner.readOnly.title')}>
          {t('banner.readOnly.text')}
        </Banner>
      )}
      {isOwner && !user.totpEnabled && (
        <Banner tone="info" title={t('banner.twofa.title')} actions={<Link to="/instellingen/profiel#tweestaps" className="btn btn--secondary btn--sm">{t('banner.twofa.action')}</Link>}>
          {t('banner.twofa.text')}
        </Banner>
      )}
    </div>
  );
}
